import React, { useState } from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';

const COLORS = ['#00E5FF', '#7B2FBE', '#10B981', '#F59E0B', '#EC4899', '#8B5CF6', '#06B6D4', '#6B7280'];

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const d = payload?.[0];
  return (
    <div className="bg-[#0D1B2A] border border-[rgba(0,229,255,0.2)] rounded-xl p-3 shadow-xl">
      <p className="text-[#E2E8F0] text-xs font-medium">{d?.name}</p>
      <p className="text-[#00E5FF] text-xs font-mono">${d?.value?.toLocaleString()}</p>
      <p className="text-[#64748B] text-xs">{d?.payload?.pct?.toFixed(1)}%</p>
    </div>
  );
};

export default function CategoryDonut({ data }) {
  const [activeIdx, setActiveIdx] = useState(null);
  const total = data?.reduce((s, d) => s + d?.value, 0);
  const enriched = data?.map((d) => ({ ...d, pct: total > 0 ? (d?.value / total) * 100 : 0 }));

  return (
    <div className="bg-[rgba(255,255,255,0.03)] border border-[rgba(0,229,255,0.1)] rounded-xl p-5">
      <h3 className="text-[#E2E8F0] font-semibold text-sm mb-4">Category Distribution</h3>
      <div className="flex flex-col lg:flex-row items-center gap-4">
        <ResponsiveContainer width={200} height={200}>
          <PieChart>
            <Pie
              data={enriched}
              cx="50%" cy="50%"
              innerRadius={55} outerRadius={85}
              paddingAngle={2}
              dataKey="value"
              onMouseEnter={(_, idx) => setActiveIdx(idx)}
              onMouseLeave={() => setActiveIdx(null)}
            >
              {enriched?.map((entry, idx) => (
                <Cell
                  key={entry?.name}
                  fill={COLORS?.[idx % COLORS?.length]}
                  opacity={activeIdx === null || activeIdx === idx ? 1 : 0.4}
                  stroke="none"
                />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
        <div className="flex-1 space-y-2 w-full">
          {enriched?.map((d, idx) => (
            <div key={d?.name} className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: COLORS?.[idx % COLORS?.length] }} />
                <span className="text-xs text-[#94A3B8]">{d?.name}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xs font-mono text-[#E2E8F0]">${d?.value?.toLocaleString()}</span>
                <span className="text-xs text-[#64748B] w-10 text-right">{d?.pct?.toFixed(1)}%</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
